import { CartItem, MembershipIntentMultiResponse } from '@repo/types';
import {
    addMembershipToCartItems,
    removeInvalidCartItems,
    removeMembershipFromCartItems,
} from '@repo/widget-utils/cart/cartUtils';
import { useMemo } from 'react';

export default function useCartItemsWithMembershipAddedOrRemoved(
    cartItems: CartItem[],
    isUsingPaymentPlan: boolean,
    paymentPlanResponse: MembershipIntentMultiResponse | null,
) {
    return useMemo(() => {
        const validCartItems = removeInvalidCartItems(cartItems);
        return paymentPlanResponse && isUsingPaymentPlan
            ? addMembershipToCartItems(validCartItems, paymentPlanResponse)
            : removeMembershipFromCartItems(validCartItems);
    }, [cartItems, paymentPlanResponse, isUsingPaymentPlan]);
}
